import { createAction } from "redux-actions";
import { SEND_EMAIL } from "../constants";
import { feathersCreateData } from "../services";

export const sendEmail = createAction(SEND_EMAIL, (data) => feathersCreateData('send-email',data )());